var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner spinner--double-bounce",style:(_vm.styles)},[_c('div',{staticClass:"double-bounce1",style:(_vm.bounceStyle)}),_c('div',{staticClass:"double-bounce2",style:(_vm.bounceStyle)})]),_c('div',{staticClass:"spinner-message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }